import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataStateKeeperService {
  private dataState$: Subject<any> = new Subject();
  private isUnSavedDataExist: boolean = false;
  constructor() { }
  setDataState() {
    this.dataState$.next(true);
  }
  getDataStateSubscription(): Observable<any> {
    return this.dataState$;
  }

  setIsUnsavedDataExist(value: boolean) {
    this.isUnSavedDataExist = value;
  }
  getIsUnsavedDataExist(): boolean {
    return this.isUnSavedDataExist;
  }
}
